// @mui
import { Box, Theme } from "@mui/material";
import { ChevronLeft } from "lucide-react";
// components
import { IconButtonAnimate } from "components/animate";

type Props = {
  onToggleCollapse: VoidFunction;
  collapseClick: boolean;
  theme: Theme;
};

export default function CollapseButton({
  onToggleCollapse,
  collapseClick,
  theme,
}: Props) {
  return (
    <IconButtonAnimate onClick={onToggleCollapse}>
      <Box
        sx={{
          lineHeight: 0,
          transition: (theme) =>
            theme.transitions.create("transform", {
              duration: theme.transitions.duration.shorter,
            }),
          ...(collapseClick && {
            transform: "rotate(180deg)",
          }),
        }}
      >
        <ChevronLeft strokeWidth={1.5} color={theme.palette.text.primary} />
      </Box>
    </IconButtonAnimate>
  );
}
